import { UserOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography } from 'antd';
import moment from 'moment';

import MultilineParagraph from '../../components/MultilineParagraph';
import styles from './ApplicantHistory.module.css';

interface ApplicantGivenUpTimelineProps {
  comment?: string;
  recruiterName: string;
  createdDate: string;
  opportunityTitle: string;
}

const ApplicantGivenUpTimeline = ({
  comment,
  recruiterName,
  createdDate,
  opportunityTitle,
}: ApplicantGivenUpTimelineProps) => {
  return (
    <Timeline.Item dot={<UserOutlined className={styles.warningColor} />}>
      <Card>
        <Typography.Paragraph>
          <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
          <br />
          <Typography.Text strong>{recruiterName}</Typography.Text> marcou o(a) candidato(a) como
          desistente na vaga <Typography.Text strong>{opportunityTitle}</Typography.Text>
        </Typography.Paragraph>
        {comment && (
          <>
            <Divider />
            <MultilineParagraph>{comment}</MultilineParagraph>
          </>
        )}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantGivenUpTimeline;
